import WildAppResource from "./WildAppResource";
import FormAppResource from "./FormAppResource";
import DisclosureAppResource from "./DisclosureAppResource";
import UserAppResource from "./UserAppResource";
import FileAppResource from '@sellers-shield-home-protection/ss-core-js/src/AppResources/FileAppResource';
import Engine from 'ss-js-engine/src/Engine';

class JotFormDisclosureSessionAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'jot-form-disclosure-session';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'jots/forms/disclosures/sessions';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'submissionId',
            'formUuid',
            'disclosureUuid',
            'userUuid',
            'outputDocumentGeneratorUuid',
            'updatedAt',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            form: FormAppResource,
            disclosure: DisclosureAppResource,
            user: UserAppResource,
            files: FileAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            form: 'form_uuid',
            disclosure: 'disclosure_uuid',
            user: 'user_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {};
    }

    apiPaths () {
        return {
            ...super.apiPaths(),
            pdf: Engine.apiUrl('jot-form/disclosure/pdf/{submissionId}/{accessToken}'),
            submissionEdit: Engine.apiUrl('jot-form/disclosure/edit/{submissionId}/{accessToken}'),
        }
    }

    async savePdf(accessToken) {
        if (!this.submissionId) {
            console.error('Cannot save PDF. Missing submissionId');

            return;
        }

        const url = this.apiPaths().pdf.replace('{submissionId}', this.submissionId).replace('{accessToken}', accessToken);
        let apiResponse = await Engine.post(url);

        return apiResponse;
    }

    async editSubmission(accessToken) {
        if (!this.submissionId) {
            console.error('Cannot edit submission. Missing submissionId');

            return;
        }

        const url = this.apiPaths().submissionEdit.replace('{submissionId}', this.submissionId).replace('{accessToken}', accessToken);
        let apiResponse = await Engine.post(url);

        return apiResponse;
    }

}

export default JotFormDisclosureSessionAppResource;
